import microuniversoApi from "app/api/microuniversoApi"
import { PagedMessageResponse } from "app/api/types/PagedMessageResponse"
import { Breadcrumb2Container } from "app/components/breadcrumb2/Breadcrumb2Container"
import { useMenuConsultaProduto } from "app/components/menu-consulta-produtos/useMenuConsultaProduto"
import { useAppSelector } from "app/redux/hooks"
import { IItemOrcamento } from "app/types/IItemOrcamento"
import { tratamentoErroPadrao } from "app/use-cases"
import { Dict } from "app/utils/Dict"
import globalMU from "globalMU"
import React, { useEffect, useRef, useState } from "react"
import { ConsultaOrdemDeProducaoAberto, DadosOrdemProducaoEmAberto } from "./ConsultaOrdemDeProducaoAberto"

export type ConsultaOrdemDeProducaoAbertoContainerProps = {
    item: IItemOrcamento,
    onVoltar: () => void,
    onRemover: () => void,
    passos: Dict<string, () => void>,
    foraOrcamento: boolean
}

export const ConsultaOrdemDeProducaoAbertoContainer = (props: ConsultaOrdemDeProducaoAbertoContainerProps) => {
    const orcamento = useAppSelector((store) => store.orcamento);


    const [dadosOrdemProducao, setDadosOrdemProducao] = useState<Partial<PagedMessageResponse<DadosOrdemProducaoEmAberto>>>({})

    const passosInterno = useRef<Dict<string, () => void>>(new Dict(Object.assign({}, props.passos.map)))
    useMenuConsultaProduto(new Dict(Object.assign({}, props.passos.map)), props.onVoltar, props.item, props.foraOrcamento)


    const onObterDadosOrdemProducao = async (numeroPagina?: number) => {
        try {
            globalMU.blockUI();
            const resposta = await microuniversoApi.Produto.listarProdutosOrdemProducao(orcamento.IdentificadorOrcamento, {
                CodigoProduto: props.item.Codigo,
                NumeroPagina: numeroPagina ?? 1,
                TamanhoPagina: 10
            });

            !("HasErrors" in resposta) ?
                setDadosOrdemProducao(resposta) :
                (setDadosOrdemProducao({}), onVoltar())

        }
        catch (e) {
            tratamentoErroPadrao(e);
            onVoltar()
        }
        finally {
            globalMU.unblockUI();
        }
    }

    const onPassoSelecionado = (passo: string) => {
        props.onRemover()
        passosInterno.current.get(passo)()
    }

    const onVoltar = () => {
        props.onRemover()
        props.onVoltar()
    }

    useEffect(() => {
        passosInterno.current.set("Consulta de Ordem de Produção em Aberto", () => { })
        onObterDadosOrdemProducao()
    }, [])

    return (
        <>
            <Breadcrumb2Container
                passos={passosInterno?.current?.keysToList()}
                exibirBotaoLimpar={false}
                exibirBotaoVoltar={true}
                id="ConsultaOrdemDeProducaoAbertoContainer"
                onPassoSelecionado={onPassoSelecionado}
                onBotaoVoltarClicado={onVoltar}
            />

            <ConsultaOrdemDeProducaoAberto
                item={props.item}
                onAlterarListaSelecionada={onObterDadosOrdemProducao}
                dadosOrdemProducao={dadosOrdemProducao}
            />
        </>
    )
}